<template>
  <gg-modal :is-active="isActive" @close="close">
    <template v-slot:toolbar>
      Create Catch-all
    </template>
    <template v-slot:body>
      <p class="body-2">
        Mail sent to any address on <strong>{{ mailbox.domain }}</strong> that has no
        mailbox, alias or forwarder will be delivered to <strong>{{ mailbox.email }}</strong>.
      </p>
      <gg-loading v-if="loading" :loading="true" type="list-item" />
      <p v-else-if="isCurrent" class="body-2 mb-0">
        This mailbox is already the catch-all for {{ mailbox.domain }}.
      </p>
      <p v-else-if="current" class="body-2 mb-0">
        Unrouted mail for {{ mailbox.domain }} currently goes to
        <strong>{{ current }}</strong>. It will be replaced.
      </p>
    </template>
    <template v-slot:actions>
      <v-spacer></v-spacer>
      <gg-btn secondary @click="close">Cancel</gg-btn>
      <gg-btn primary :loading="saving" :disabled="loading || isCurrent" @click="save">
        Create Catch-all
      </gg-btn>
    </template>
  </gg-modal>
</template>

<script>
import { mapActions } from 'vuex'

/**
 * Point a domain's unrouted mail at this mailbox (AM-1106) — cPanel's "default
 * address". There is one per domain, so the current target is shown first:
 * saving replaces it.
 */
export default {
  name: 'CatchAllModal',
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    mailbox: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      current: null,
      loading: false,
      saving: false,
    }
  },
  computed: {
    isCurrent () {
      return !!this.current &&
        this.current.toLowerCase() === this.mailbox.email.toLowerCase()
    },
  },
  methods: {
    ...mapActions('emailHub', ['loadDefaultAddress', 'setCatchAll']),
    ...mapActions(['reportError', 'reportSuccess']),
    close () {
      this.$emit('close')
    },
    async open () {
      this.current = null
      this.loading = true
      try {
        this.current = await this.loadDefaultAddress({
          serviceId: this.mailbox.serviceId,
          domain: this.mailbox.domain,
        })
      } catch (e) {
        // Only informational; saving still works without it.
        console.warn('CatchAllModal: unable to read the current default address', e)
      } finally {
        this.loading = false
      }
    },
    async save () {
      this.saving = true
      try {
        await this.setCatchAll({
          serviceId: this.mailbox.serviceId,
          domain: this.mailbox.domain,
          email: this.mailbox.email,
        })
      } catch (e) {
        this.saving = false
        this.reportError(e)
        return
      }

      this.saving = false
      this.reportSuccess(`Unrouted mail for ${this.mailbox.domain} now goes to ${this.mailbox.email}.`)
      this.close()
    },
  },
  watch: {
    isActive (active) {
      if (active) this.open()
    },
  },
  // Mounted already open from the dashboard row — see AddAliasModal.open().
  created () {
    if (this.isActive) this.open()
  },
}
</script>
